














import { Vue, Component } from 'vue-property-decorator';
import { SwIcon } from '@libs/unified-ui-framework/src/shared/sw-icon';
import { SwButton } from '@libs/unified-ui-framework/src/shared/sw-button';

const cssPrefix = 'sw-ftr-worldwide-attacks';

@Component({
  components: {
    SwIcon,
    SwButton,
  },
})
export default class SwFtrWorldwideAttacks extends Vue {
  cssPrefix = cssPrefix;
}
